import { BreakpointsOptions } from './styles.interface';

export const DEFAULT_FONT_FAMILY =
  'BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif';
export const DEFAULT_FONT_SIZE = 14;
export const DEFAULT_LIGHT_THEME_ACCENT_COLOR = 'hsl(214.9, 100%, 32.4%)';
export const DEFAULT_LIGHT_THEME_FONT_COLOR = 'hsl(0.0, 0%, 19%)';
export const DEFAULT_LIGHT_THEME_NEUTRAL_COLOR = 'hsl(0.0, 0%, 96.0%)';

export const FONT_WEIGHT_LIGHT = 250;
export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_SEMI_BOLD = 550;
export const FONT_WEIGHT_BOLD = 700;

export const DEFAULT_MAX_SIDE_AND_CENTER_CONTAINER_WIDTH = 625;
export const DEFAULT_MAX_BANNER_WIDTH = 5000;

export const DEFAULT_BORDER_RADIUS = '4px';
export const DEFAULT_LAYER_BORDER_RADIUS = '4px';
export const DEFAULT_LAYER_COLOR = '#fff';
export const DEFAULT_OVERLAY_COLOR = '#333';
export const DEFAULT_OVERLAY_OPACITY = 0.7;

export const DEFAULT_ACTIVE_TOGGLE = '#336AB7';
export const DEFAULT_DISABLED_TOGGLE = '#dedede';
export const DEFAULT_INACTIVE_TOGGLE = '#595959';
export const DEFAULT_TOGGLE_ICON = '#ffffff';

export const breakpoints: BreakpointsOptions = {
  lg: 992,
  md: 768,
  sm: 600,
  xl: 1200,
  xs: 400,
  xxl: 1472,
  xxxl: 10000,
};
